/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";



import { FaGreaterThan, FaLessThan } from "react-icons/fa6";
import { StyledTablePaginator } from "../../../../styles/components/tables";
import { tableType } from "../../../../enums";
import { buildPagesNumbers } from "../../../../utils";



interface ITablePaginatorProps {
    totalPages: number,
    tableType: tableType,
    currentPage: number,
    setCurrentPage: any
}

/**
 * 
 * @param props 
 * @returns 
 */
export const TablePaginator = ({ totalPages, setCurrentPage, tableType, currentPage }: ITablePaginatorProps) => {

    const [activeBtn, setActiveBtn] = useState(1);

    const [pages, setPages] = useState<Array<number>>([1]);

  

    useEffect(()=> {
        setPages([...buildPagesNumbers(totalPages)])
    },[totalPages])


    const handlePageChange = (e: any) => {
        setCurrentPage(e);
 
    }


    return (<StyledTablePaginator>
        <div className="flex justify-evenly items-center font-semibold gap-4 text-[#5C6265]">
            {activeBtn > 1 && ( // Show the previous button if activeBtn is greater than 1
                <div
                    className="previous rounded-xl p-2 bg-[#50799E] flex justify-center items-center"
                    style={{ cursor: "pointer" }} onClick={() => { setActiveBtn(activeBtn - 1); handlePageChange(activeBtn + 1); }}>
                    <FaLessThan color='white' className="font-bold"/>
                </div>
            )}
            {pages?.map((btn: number) => (
                (btn === activeBtn || btn === activeBtn - 1 || btn === activeBtn + 1) && (
                    <button
                        onClick={() => {
                            setActiveBtn(btn);
                            handlePageChange(btn);
                        }}
                        className={`${btn === activeBtn ? "actv-btn text-[#50799E]" : ""}`}
                        key={btn}
                    >
                        {btn}
                    </button>
                )
            ))}
            {activeBtn < pages.length && ( // Hide the next button if activeBtn is the last page
                <div className="rounded-xl p-2 bg-[#50799E] flex justify-center items-center" onClick={() => { setActiveBtn(activeBtn + 1); handlePageChange(activeBtn + 1); }}>
                   <FaGreaterThan color='white' className="font-bold"/>
                </div>
            )}
        </div>

    </StyledTablePaginator>)
}